
import RideitInvitation from '@/models/Rideit/RideitInvitation';
import RideitPassengerToken from '@/models/Rideit/RideitPassengerToken';
import { IDataTableHeader, IDataTableItemsSlotProps } from '@/typings/dataTable';
import {Component, Prop, Vue} from 'vue-property-decorator';
import RideitPassengerTokenDialog from './RideitPassengerTokenDialog.vue';
import RideitInvitationsStatus from './RideitInvitationsStatus.vue';
import PassengerWithSms from '@/components/Passenger/models/PassengerWithSms';
import { IRideitInvitationTableItem } from '@/util/rideitHelper';




@Component({
  components: {
    RideitPassengerTokenDialog,
    RideitInvitationsStatus,
  }
})
export default class RideitInvitationTableItem extends Vue {

  @Prop({ required: true }) private item: IRideitInvitationTableItem;
  @Prop({ required: true }) private headers: IDataTableHeader[];
  @Prop({ required: true }) private props: IDataTableItemsSlotProps;

  tokenDialog = false;

  get selected() {
    return this.item.selected;
  }
  set selected(value: boolean) {
    this.item.selected = value;
    this.$emit('update:selected', this.item);
  }

  get tokensDisabled() {
    return this.item.tokens.length === 0;
  }

  get tags() {
    return this.item.tags.split(',').filter(t => t.trim() !== '');
  }

  toggleTokenDialog() {
    this.tokenDialog = !this.tokenDialog;
  }

  cancelToken(token: RideitPassengerToken) {
    this.$emit('cancel-token', token);
  }

}
